module.exports = require("./mg.d.ts");